import { useMemo } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { SourceTypeE } from "../api/types/common";
import MuiIcon, { IconName } from "../../components/MuiIcon";
import useGetColors from "../hooks/useGetColors";

const iconNameByType: Partial<Record<SourceTypeE, IconName>> = {
  [SourceTypeE.CHANNEL_ENTITY]: "people",
  [SourceTypeE.BOT_ENTITY]: "smart_toy",
  [SourceTypeE.SERVICE_ENTITY]: "settings",
  [SourceTypeE.MANAGER_ENTITY]: "engineering",
};

interface Props {
  resourceName: string;
  resourceType: SourceTypeE;

  disabledIcon?: boolean;
  disabledType?: boolean;
}
export const ResourceSelectLabel = ({ resourceName, resourceType, disabledIcon = false, disabledType = false }: Props) => {
  const colors = useGetColors();

  const resourceTypeText = useMemo(() => resourceType.replace("Entity", ""), [resourceType]);

  return (
    <Flex w="100%" alignItems="center" gap={2} flexWrap="wrap">
      {iconNameByType[resourceType] && !disabledIcon && (
        <MuiIcon
          size={24}
          fill
          name={iconNameByType[resourceType]}
          color={colors.brand400}
        />
      )}
      {!disabledType &&
        <Text opacity={0.6} fontSize="sm">
          [{resourceTypeText}]
        </Text>
      }
      <Text>{resourceName}</Text>
    </Flex>
  );
};
